import AbilityHelper from './abilityhelpers/AbilityHelper';

class AbilityProvider {
  abilityHelper = new AbilityHelper();

  getAbilityHelper() {
    return this.abilityHelper;
  }
}

export default new AbilityProvider();
